import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { AccountGroup } from '../../../domain/public-api';

export enum AccountGroupLabelType {
  SHORT = 'short',
  LONG = 'long'
}

@Component({
  selector: 'td-wb-account-group-label',
  templateUrl: 'account-group-label.component.html',
  styleUrls: ['account-group-label.component.scss'],
  imports: [
    NgTemplateOutlet
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountGroupLabelComponent {

  @Input() accountGroup: AccountGroup;
  @Input() type: AccountGroupLabelType = AccountGroupLabelType.LONG;
  @ViewChild('shortLabelTemplate', { static: true }) shortLabelTemplate: TemplateRef<unknown>;
  @ViewChild('longLabelTemplate', { static: true }) longLabelTemplate: TemplateRef<unknown>;

  constructor() {
  }

  getTemplate(): TemplateRef<unknown> {
    switch (this.type) {
      case(AccountGroupLabelType.SHORT):
        return this.shortLabelTemplate;
      case AccountGroupLabelType.LONG:
        return this.longLabelTemplate;
      default:
        return this.longLabelTemplate;
    }
  }
}
